module.exports = __webpack_public_path__ + "img/duende.4392af8c.png";